import {getOrganizationKey} from '@bluedrop-learning-networks/frontend-utils';
import {setupAppConfig} from '@/src/utils/appConfig';

async function _loadRemoteConfig() {
	try {
		const {protocol, host} = window.location;
		const url = `${protocol}//${host}${window.__APP_PREFIX}config.json`;
		const response = await fetch(url, {method: 'GET'});
		const data = await response.json();
		return setupAppConfig(data);
	} catch (cause) {
		throw new Error('Unable to load and parse config.json', {cause});
	}
}

async function bootstrap() {
	const organizationKey = getOrganizationKey();
	const redirectUrl = `https://${organizationKey}.support.bluedrop360.com/support/solutions`;
	window.location.replace(redirectUrl);
}

bootstrap();
